import React from "react";
import PropTypes from "prop-types";
import { motion, AnimatePresence } from "framer-motion";

const overlayVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
  exit: { opacity: 0, transition: { duration: 0.15 } },
};

const modalVariants = {
  hidden: { opacity: 0, scale: 0.95, y: -10 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { duration: 0.25, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    y: -10,
    transition: { duration: 0.2, ease: "easeIn" },
  },
};

const SessionExpiredModal = ({ visible, onLogout }) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center"
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={overlayVariants}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

          {/* Modal content */}
          <motion.div
            className="relative bg-white rounded-lg shadow-lg w-full max-w-md overflow-hidden"
            variants={modalVariants}
          >
            <div className="bg-blue-600 px-6 py-4">
              <h2 className="text-lg font-bold text-white">
                Phiên làm việc đã hết hạn
              </h2>
            </div>
            <div className="p-6">
              <p className="text-gray-700 mb-6 text-sm leading-relaxed">
                Phiên làm việc của bạn đã hết hạn. Vui lòng đăng nhập lại để
                tiếp tục.
              </p>
              <div className="flex justify-end">
                <button
                  onClick={onLogout}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                >
                  Đăng nhập lại
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

SessionExpiredModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default SessionExpiredModal;
